// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions-panel__option[data-v-fc3553b0]{display:flex;flex-direction:column;align-items:center;border-bottom:1px solid #e0e0e0;padding:5px 0}", ""]);
// Exports
module.exports = exports;
